import { useMemo, useState } from 'react'
import { useStaticData } from '@mc/static-data-react'
import { EPISODE_ORDERINGS } from 'pages/series/[slug]/utils/episodeOrdering'
import { Chapter } from 'types/data'
import { EpisodeStaticData } from '../../../[episodeSlug].page'

const groupEpisodes = (episodes: Chapter[]) =>
  episodes.reduce<Chapter[][]>((acc, episode, index) => {
    const indexToSave = Math.floor(index / 3)
    if (!acc[indexToSave]) {
      acc[indexToSave] = []
    }
    acc[indexToSave].push(episode)
    return acc
  }, [])

export const useEpisodeList = () => {
  const {
    course,
    episode: currentEpisode,
    episodeOrdering,
  } = useStaticData<EpisodeStaticData>()

  const [showAll, setShowAll] = useState(false)

  const episodes = useMemo(
    () => [
      ...(course.sortedChapters as Chapter[]),
      ...(course.upcomingChapters as Chapter[]),
    ],
    [course.sortedChapters, course.upcomingChapters],
  )

  const orderedEpisodes = useMemo(() => {
    if (episodeOrdering === EPISODE_ORDERINGS.REVERSE_CHRONOLOGICAL) {
      // assumes that the episodes are already sorted in chronological order
      return episodes.reverse()
    }
    return episodes
  }, [episodes, episodeOrdering])

  const filteredEpisodes = orderedEpisodes.filter(
    (e) => e.id !== currentEpisode.id,
  )

  const allGroupedEpisodes = groupEpisodes(filteredEpisodes)
  const groupedEpisodes = showAll
    ? allGroupedEpisodes
    : allGroupedEpisodes.slice(0, 1)

  return { showAll, setShowAll, groupedEpisodes, episodes: filteredEpisodes }
}
